import React, { useEffect, useState } from "react";
import {
  EmailAuthProvider,
  deleteUser,
  reauthenticateWithCredential,
  signInWithCredential,
} from "firebase/auth";
import { doc, deleteDoc } from "firebase/firestore";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { auth, db } from "../firebase";

const DeleteAccount = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [confirmed, setConfirmed] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const resetFields = () => {
    setEmail("");
    setPassword("");
    setLoading(false);
  };

  const firebaseSignInErrorCode = (error) => {
    switch (error.code) {
      case "auth/invalid-credential":
        setError("Invalid Credentials");
        break;

      case "auth/invalid-email":
        setError("Invalid Credentials");
        break;

      case "auth/invalid-password":
        setError("Invalid Credentials");
        break;

      case "auth/network-request-failed":
        setError(
          "Network request failed. Please check your internet connection"
        );
        break;

      default:
        setError("Something went wrong! Please try again");
        break;
    }
  };

  const userDoc = async (user_id, db) => {
    const cloudFuncUrl = `https://us-central1-findme-b45e4.cloudfunctions.net/deleteUserFiles?uid=${user_id}`;

    fetch(cloudFuncUrl);
    // .then(() => console.log("Photos deleted"))
    // .catch(() => console.log("No Photos"));

    await deleteDoc(doc(db, "business", user_id));
    // .then(() => console.log("Biz Documents deleted"))
    // .catch(() => console.log("No Biz Documents"));
    await deleteDoc(doc(db, "clients", user_id));
    // .then(() => console.log("Client Documents deleted"))
    // .catch(() => console.log("No Client Documents"));
    await deleteDoc(doc(db, "comments", user_id));
    // .then(() => console.log("Comments deleted"))
    // .catch(() => console.log("No Comments"));
    await deleteDoc(doc(db, "notifications", user_id));
    // .then(() => console.log("notifications deleted"))
    // .catch(() => console.log("No notifications"));
    await deleteDoc(doc(db, "profileRatings", user_id));
    // .then(() => console.log("profileRatings deleted"))
    // .catch(() => console.log("No profileRatings"));
    await deleteDoc(doc(db, "reportedProfiles", user_id));
    // .then(() => console.log("reportedProfiles deleted"))
    // .catch(() => console.log("No reportedProfiles"));
  };

  const deleteAccount = async () => {
    setLoading(true);
    setConfirmed("");
    setError("");

    const authCredential = EmailAuthProvider.credential(email, password);
    await signInWithCredential(auth, authCredential)
      .then((userSignedIn) =>
        reauthenticateWithCredential(userSignedIn.user, authCredential)
          .then((userCredential) => {
            deleteUser(userCredential.user)
              .then(() => {
                // User deleted.
                userDoc(userSignedIn.user.uid, db)
                  .then(() => {
                    // alert("Account deleted successfully");
                    setConfirmed("Your account has been deleted! 😢");
                    resetFields();
                    handleClose();
                  })
                  .catch((error) => {
                    // An error occurred
                    // console.log("Error => ", error);
                    setError(
                      "Failed to delete account. Please try again later!"
                    );
                    resetFields();
                    handleClose();
                  });
                // https://us-central1-findme-b45e4.cloudfunctions.net/deleteUserFiles?uid=EjeTi2z8iYWEgAprkKOuTgYYaWm1
              })
              .catch((error) => {
                // An error ocurred
                // console.log("Error AccDelete => ", error);
                setError("Failed to delete account. Please try again later!");
                resetFields();
                handleClose();
              });
          })
          .catch((error) => {
            // An error ocurred
            // console.log("Error 1 => ", error);
            setError("Failed to delete account. Please try again later!");
            resetFields();
            handleClose();
          })
          .finally(() => {
            auth.signOut();
            resetFields();
            handleClose();
          })
      )
      .catch((error) => {
        // An error ocurred
        // console.log("Error 2 => ", error);
        firebaseSignInErrorCode(error);
        resetFields();
        handleClose();
      });
  };

  useEffect(() => {
    document.title = "SearchMe - Delete Account";
    // firebaseEmailConfig();
  }, []);

  return (
    <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
      <header className="mb-auto">
        <div>
          <img
            src="../logo/Logo.png"
            height="55"
            width="55"
            alt="SearchMe"
            className="mx-auto mb-0"
          />
        </div>
      </header>

      <main className="px-3">
        <h3 className="h1-search fw-bold">Delete Account</h3>

        <div className="mt-3">
          {loading && (
            <div className="lds-spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          )}
          {error && <p className="text-danger">{error}</p>}
          {confirmed && <p className="h1-search">{confirmed}</p>}
        </div>

        <div className="mt-3" style={{ minWidth: 300 }}>
          <div className="mb-3 text-start">
            <label
              htmlFor="exampleInputEmail1"
              className="form-label h1-search"
            >
              Email*
            </label>
            <input
              type="email"
              className="form-control form-control-sm shadow-none"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mb-3 text-start">
            <label
              htmlFor="exampleInputPassword1"
              className="form-label h1-search"
            >
              Password*
            </label>
            <input
              type="password"
              className="form-control form-control-sm shadow-none"
              id="exampleInputPassword1"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <Button
            size="sm"
            data-bs-toggle="modal"
            data-bs-target="#deleteAccModal"
            // onClick={deleteAccountNoti}
            onClick={handleShow}
            variant="outline-success"
            className="shadow-none"
          >
            Submit
          </Button>
        </div>

        <div className="mt-3">
          <p className="h1-search">
            <span className="text-danger">Note:</span> You are about to delete
            your account and all it's data.
          </p>
        </div>
      </main>

      {/* <!-- Modal --> */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body>
          <h5 className="h1-search">
            Are you sure you want to delete your account?
          </h5>
          <p style={{ color: "red" }}>This action cannot be undone!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handleClose}
            className="shadow-none"
          >
            Close
          </Button>
          <Button
            variant="outline-success"
            size="sm"
            onClick={deleteAccount}
            className="shadow-none"
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>

      <footer className="mt-auto h1-search">
        <p>&copy; SearchMe 2025</p>
      </footer>
    </div>
  );
};

export default DeleteAccount;
